import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const REFRIGERANT_TYPES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('REFRIGERANT_TYPES');
export const REFRIGERANT_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	REFRIGERANT_TYPES_CRUD_ACTION_CONSTANTS
);
